import { createApi } from "../../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import { checkForImmixOrSureviewOrSentinel } from "./checkForImmixOrSureviewOrSentinel";
import { fetchAddCameraInfo } from "../../SitesPage/SitesPageUtils/fetchAddCameraInfo";
import {
  AlertState,
  Dispatcher,
  ExtraFields,
  SiteCamerasResult,
} from "./siteAboutInterfaces";
import { GeneralInfoTab } from "../GeneralInfoTab";
import { SchedulesTab } from "../SchedulesTab";
import { checkArmedStatus } from "./checkArmedStatus";
import { getRecordingServerData } from "./getRecordingServerData";
import { universalAPIErrorHandler } from "../../../../utils/universalAPIErrorHandler";
import {
  isResourceNotFoundError,
  navigateToResourceNotFound,
} from "../../../../utils/resourceNotFound";
import { integrationsMatcher } from "../../../../utils/integrationsMatcher";
import { temporaryUpdateScheduleData } from "./temporaryUpdateScheduleData";
import { checkForUseMotion } from "./checkForUseMotion";
import { useSiteAboutStore } from "../siteAboutStore/siteAboutStore";
import { isChmOnlyIgnoreZones } from "./isChmOnlyIgnoreZones";
import { addIgnoreLabel } from "./addIgnoreLabel";

export const handleGetAllData = async (
  siteId: any,
  navigate: any,
  setSiteInfo: any,
  setSiteSchedules: any,
  setSiteCameras: any,
  setActiveTab: any,
  setDataLoaded: any,
  setBackdropLoadingScreenOn: any,
  setAllSiteSchedules: any,
  setVmsVariables: any,
  setNoAutoAddCamerasDialogOpen: any,
  setArmedStatus: any,
  setAiLinkSite: any,
  setSiteDeployed: any,
  setSyncNeeded: any,
  setAlertState: any,
  setCamerasNotDeployed: any,
  setToolTipTitle: any,
  setConfigureMotion: any,
  setPatchObject: any,
  setArmButtonDisabled: any,
  setRecordingServerData: any,
  setRecordingServerPatchObject: any,
  setRecordingServerVisible: Dispatcher<boolean>,
  setHealthCheckData: any,
  setWebhooksInfo: any,
  setWebhooksPatchObject: any,
  getIsMounted?: () => boolean,
  onLoadingPhaseChange?: (
    phase:
      | "site-metadata"
      | "site-extra-fields"
      | "site-cameras"
      | "site-schedules-and-health"
      | "camera-row-prefetch-start"
      | "camera-row-prefetch-progress"
      | "camera-row-prefetch-complete",
    progress?: {
      completed: number;
      total: number;
    }
  ) => void
) => {
  const emitLoadingPhase = (
    phase:
      | "site-metadata"
      | "site-extra-fields"
      | "site-cameras"
      | "site-schedules-and-health"
      | "camera-row-prefetch-start"
      | "camera-row-prefetch-progress"
      | "camera-row-prefetch-complete",
    progress?: {
      completed: number;
      total: number;
    },
    _location: string = "handleGetAllData"
  ) => {
    onLoadingPhaseChange?.(phase, progress);
  };

  localStorage.setItem("siteId", siteId);
  let autoAdd = true;
  // let noAutoAddCamerasDialogOpen = true;
  let siteCameraCount = 0;
  let siteInfoSettingsDeployed = true;
  const AxiosUI = createApi(``);
  const {
    getFlexSchedules,
    getNonFlexSchedules,
    setFlexSchedulesOn,
    setHealthCheckDataZustand,
    setBackupWebhookData,
    getAutoPatrolCameraProducts,
    getActiveCameraProductsForAllCameras,
    getLineCrossingsData,
    setChmOnlyIgnoreZonesByCamera,
    setCameraStatusById,
    setIgnoreZonesByCamera,
    setMetadataTagZonesByCamera,
    setRowPrefetchStateByCamera,
  } = useSiteAboutStore.getState();
  setChmOnlyIgnoreZonesByCamera({});
  setCameraStatusById({});
  setIgnoreZonesByCamera({});
  setMetadataTagZonesByCamera({});
  setRowPrefetchStateByCamera({});
  const retryFunction = () => {
    handleGetAllData(
      siteId,
      navigate,
      setSiteInfo,
      setSiteSchedules,
      setSiteCameras,
      setActiveTab,
      setDataLoaded,
      setBackdropLoadingScreenOn,
      setAllSiteSchedules,
      setVmsVariables,
      setNoAutoAddCamerasDialogOpen,
      setArmedStatus,
      setAiLinkSite,
      setSiteDeployed,
      setSyncNeeded,
      setAlertState,
      setCamerasNotDeployed,
      setToolTipTitle,
      setConfigureMotion,
      setPatchObject,
      setArmButtonDisabled,
      setRecordingServerData,
      setRecordingServerPatchObject,
      setRecordingServerVisible,
      setHealthCheckData,
      setWebhooksInfo,
      setWebhooksPatchObject,
      getIsMounted,
      onLoadingPhaseChange
    );
  };
  let getSiteInfoFail = true;
  // let getNVRCamerasFail = true;
  let getExtraFieldsFail = true;
  localStorage.setItem("noAutoAddCamerasDialogOpen", "true");

  let allSiteCameras: any;

  let hasFlexSchedule = false;

  let autoPatrolSite = false;

  const getSMTPIntructions = () => {
    AxiosUI.get(`customer/${siteId}/instructions/`).then(
      (response: AxiosResponse) => {
        if (response.data.show_instructions === true) {
          localStorage.setItem("SMTPSite", "true");
          localStorage.setItem(
            "SMTPInstructions",
            JSON.stringify(response.data)
          );
          setBackdropLoadingScreenOn(false);
        } else {
          localStorage.setItem("SMTPSite", "false");
          setBackdropLoadingScreenOn(false);
        }
      },
      (reason: AxiosError) => {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {
          setBackdropLoadingScreenOn(false);
        });
      }
    );
  };

  const getHealthCheckData = () => {
    AxiosUI.get(`healthcheck/by_customer/${siteId}/`).then(
      (response: AxiosResponse) => {
        setHealthCheckData(response.data);
        setHealthCheckDataZustand(response.data);
        AxiosUI.get(`webhook_customer/?customer=${siteId}`).then(
          (response: AxiosResponse) => {
            if (response.data[0]) {
              setWebhooksInfo(response.data);
              setBackupWebhookData(response.data);
            }
            emitLoadingPhase(
              "site-schedules-and-health",
              undefined,
              "handleGetAllData:getHealthCheckData-success"
            );
            setDataLoaded(true);
            if (localStorage.selectedIntegrationType === "SMTP per Camera") {
              getSMTPIntructions();
            } else {
              setBackdropLoadingScreenOn(false);
            }
          },
          (reason: AxiosError) => {
            universalAPIErrorHandler(reason, navigate, retryFunction, () => {
              // Fallback: ensure page loads even if webhook API fails
              emitLoadingPhase(
                "site-schedules-and-health",
                undefined,
                "handleGetAllData:getHealthCheckData-webhook-fallback"
              );
              setDataLoaded(true);
              if (localStorage.selectedIntegrationType === "SMTP per Camera") {
                getSMTPIntructions();
              } else {
                setBackdropLoadingScreenOn(false);
              }
            });
          }
        );
      },
      (reason: AxiosError) => {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {
          // Fallback: ensure page loads even if health check API fails
          // Try to get webhooks anyway, but if that fails too, still load the page
          AxiosUI.get(`webhook_customer/?customer=${siteId}`).then(
            (response: AxiosResponse) => {
              if (response.data[0]) {
                setWebhooksInfo(response.data);
                setBackupWebhookData(response.data);
              }
              emitLoadingPhase(
                "site-schedules-and-health",
                undefined,
                "handleGetAllData:getHealthCheckData-error-webhook-success"
              );
              setDataLoaded(true);
              if (localStorage.selectedIntegrationType === "SMTP per Camera") {
                getSMTPIntructions();
              } else {
                setBackdropLoadingScreenOn(false);
              }
            },
            () => {
              // Even if webhook also fails, still load the page
              emitLoadingPhase(
                "site-schedules-and-health",
                undefined,
                "handleGetAllData:getHealthCheckData-error-webhook-error"
              );
              setDataLoaded(true);
              if (localStorage.selectedIntegrationType === "SMTP per Camera") {
                getSMTPIntructions();
              } else {
                setBackdropLoadingScreenOn(false);
              }
            }
          );
        });
      }
    );
  };

  const allTheRestOfCalls = () => {
    useSiteAboutStore.getState().checkForEvalinkSiteId(siteId, navigate);
    if (hasFlexSchedule) {
      setFlexSchedulesOn(true);
      getFlexSchedules(
        siteCameraCount,
        setAlertState,
        getHealthCheckData,
        navigate
      );
    }
    if (!hasFlexSchedule) {
      setFlexSchedulesOn(false);
      getNonFlexSchedules(
        siteCameraCount,
        setAlertState,
        getHealthCheckData,
        navigate
      );
    }
  };

  const prefetchCameraRowData = async (
    cameras: SiteCamerasResult[],
    skipForAutoPatrol: boolean
  ): Promise<void> => {
    if (skipForAutoPatrol || !Array.isArray(cameras) || cameras.length === 0) {
      setCameraStatusById({});
      setIgnoreZonesByCamera({});
      setMetadataTagZonesByCamera({});
      setChmOnlyIgnoreZonesByCamera({});
      setRowPrefetchStateByCamera({});
      emitLoadingPhase(
        "camera-row-prefetch-complete",
        {
          completed: 0,
          total: 0,
        },
        "handleGetAllData:prefetch-empty"
      );
      return;
    }
    emitLoadingPhase(
      "camera-row-prefetch-start",
      {
        completed: 0,
        total: cameras.length,
      },
      "handleGetAllData:prefetch-start"
    );

    const cameraStatusMap: Record<number, any> = {};
    const ignoreZonesMap: Record<number, any[]> = {};
    const metadataTagZonesMap: Record<number, any[]> = {};
    const chmOnlyMap: Record<number, boolean> = {};
    const rowPrefetchStateMap: Record<
      number,
      {
        statusLoaded: boolean;
        statusFailed: boolean;
        ignoreZonesLoaded: boolean;
        ignoreZonesFailed: boolean;
        tagZonesLoaded: boolean;
        tagZonesFailed: boolean;
        lineCrossingsLoaded: boolean;
        lineCrossingsFailed: boolean;
      }
    > = {};
    let completed = 0;

    cameras.forEach((camera) => {
      rowPrefetchStateMap[camera.id] = {
        statusLoaded: false,
        statusFailed: false,
        ignoreZonesLoaded: false,
        ignoreZonesFailed: false,
        tagZonesLoaded: false,
        tagZonesFailed: false,
        lineCrossingsLoaded: !camera.has_line_crossing,
        lineCrossingsFailed: false,
      };
      chmOnlyMap[camera.id] = false;
    });

    await Promise.allSettled(
      cameras.map(async (camera) => {
        try {
          const cameraState = rowPrefetchStateMap[camera.id];

          try {
            const statusResponse = await AxiosUI.get(`/camera/${camera.id}/status/`);
            cameraStatusMap[camera.id] = statusResponse.data;
            cameraState.statusLoaded = true;
          } catch (_error) {
            cameraState.statusFailed = true;
          }

          try {
            const ignoreZonesResponse = await AxiosUI.get(
              `/camera/${camera.id}/ignore_zones/`
            );
            const normalizedIgnoreZones = addIgnoreLabel(
              ignoreZonesResponse.data || []
            );
            ignoreZonesMap[camera.id] = normalizedIgnoreZones;
            chmOnlyMap[camera.id] = isChmOnlyIgnoreZones(
              ignoreZonesResponse.data || []
            );
            cameraState.ignoreZonesLoaded = true;
          } catch (_error) {
            cameraState.ignoreZonesFailed = true;
          }

          try {
            const tagZonesResponse = await AxiosUI.get(`tagzone/?camera=${camera.id}`);
            metadataTagZonesMap[camera.id] = tagZonesResponse.data?.results || [];
            cameraState.tagZonesLoaded = true;
          } catch (_error) {
            cameraState.tagZonesFailed = true;
          }

          if (camera.has_line_crossing) {
            await getLineCrossingsData(navigate, camera.id);
            const lineCrossingsData = useSiteAboutStore.getState().lineCrossingsData;
            if (Object.prototype.hasOwnProperty.call(lineCrossingsData, camera.id)) {
              cameraState.lineCrossingsLoaded = true;
            } else {
              cameraState.lineCrossingsFailed = true;
            }
          }
        } finally {
          completed += 1;
          emitLoadingPhase(
            "camera-row-prefetch-progress",
            {
              completed,
              total: cameras.length,
            },
            "handleGetAllData:prefetch-progress"
          );
        }
      })
    );

    setCameraStatusById(cameraStatusMap);
    setIgnoreZonesByCamera(ignoreZonesMap);
    setMetadataTagZonesByCamera(metadataTagZonesMap);
    setChmOnlyIgnoreZonesByCamera(chmOnlyMap);
    setRowPrefetchStateByCamera(rowPrefetchStateMap);
    emitLoadingPhase(
      "camera-row-prefetch-complete",
      {
        completed: cameras.length,
        total: cameras.length,
      },
      "handleGetAllData:prefetch-complete"
    );
  };

  const getSiteCameras = async (
    pageNumber: number,
    autoPatrolSite: boolean
  ) => {
    await AxiosUI.get(
      `camera/site/?customer__id=${siteId}&page=${pageNumber}`
    ).then(
      async (response: AxiosResponse) => {
        if (getIsMounted && !getIsMounted()) return;
        if (response.data.count > 0) {
          // response.data.results.forEach((cameraObj: SiteCamerasResult) => {
          //   if (autoPatrolSite) {
          //     getAutoPatrolCameraProducts(navigate, Number(cameraObj.id));
          //   }
          // });
          if (pageNumber === 1) {
            allSiteCameras = response.data;
            siteCameraCount = response.data.count;
          }
          if (pageNumber > 1) {
            allSiteCameras.results.push(...response.data.results);
          }
          if (response.data.next) {
            return getSiteCameras(pageNumber + 1, autoPatrolSite);
          } else {
            localStorage.setItem("siteCameras", JSON.stringify(allSiteCameras));
            setSiteCameras(allSiteCameras);
            emitLoadingPhase(
              "site-cameras",
              undefined,
              "handleGetAllData:getSiteCameras-pre-prefetch"
            );
            await prefetchCameraRowData(
              allSiteCameras.results as SiteCamerasResult[],
              autoPatrolSite
            );
            checkForUseMotion(allSiteCameras.results);
            allTheRestOfCalls();
            if (autoPatrolSite && allSiteCameras.results?.length > 0) {
              getActiveCameraProductsForAllCameras(
                navigate,
                allSiteCameras.results.map((c: SiteCamerasResult) => c.id)
              );
            } else if (allSiteCameras.results?.length > 0) {
              checkForImmixOrSureviewOrSentinel(
                response.data.results[0].id,
                navigate
              );
            }
            if (
              siteInfoSettingsDeployed &&
              localStorage.navigatedFromEditCameraPage !== "true"
            ) {
              response.data.results.forEach((cameraObj: SiteCamerasResult) => {
                if (!cameraObj.deployed) {
                  setCamerasNotDeployed(true);
                  setSyncNeeded(true);
                }
              });
            } else if (
              siteInfoSettingsDeployed &&
              localStorage.navigatedFromEditCameraPage === "true"
            ) {
              localStorage.removeItem("navigatedFromEditCameraPage");
            }
          }
        } else {
          setSiteCameras(response.data);
          await prefetchCameraRowData([], autoPatrolSite);
          emitLoadingPhase(
            "site-cameras",
            undefined,
            "handleGetAllData:getSiteCameras-empty"
          );
          allTheRestOfCalls();
          localStorage.setItem("siteCameras", JSON.stringify(response.data));
        }
      },
      (reason: AxiosError) => {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {
          alert("Error loading site data");
          navigate(`/sites`);
        });
      }
    );
  };

  await AxiosUI.get(`customer/${siteId}/about/`).then(
    async (response: AxiosResponse) => {
      if (getIsMounted && !getIsMounted()) return;
      getSiteInfoFail = false;
      if (response.data?.has_flex_schedule) {
        hasFlexSchedule = true;
        localStorage.setItem("flexSchedulesOn", "true");
      }
      fetchAddCameraInfo(siteId, navigate, { silent: true });
      if (response.data.integration_type_name === "autopatrol") {
        autoPatrolSite = true;
      }
      localStorage.setItem(
        "selectedIntegrationType",
        integrationsMatcher("FullName", response.data.integration_type_name)
      );
      if (response.data.integration_type_name === "autopatrol") {
        await useSiteAboutStore.getState().getAutoPatrolSchedules(navigate, siteId);
      }
      if (response.data.integration_type_name === "milestone") {
        setRecordingServerVisible(true);
        getRecordingServerData(
          response.data.id,
          setRecordingServerData,
          setRecordingServerPatchObject,
          navigate
        );
      }
      localStorage.setItem("siteInfo", JSON.stringify(response.data));
      const siteInfo = response.data;
      setSiteInfo(response.data);

      // For AutoPatrol sites, also set siteInfo in Zustand store
      if (response.data.integration_type_name === "autopatrol") {
        useSiteAboutStore.getState().setSiteInfo(response.data);
      }

      checkArmedStatus(
        response.data,
        setArmButtonDisabled,
        navigate,
        setSiteInfo,
        setArmedStatus,
        getIsMounted
      );
      setPatchObject({
        name: siteInfo.name,
      });
      const newVMSVariables: any[] = [];
      siteInfo.extra_fields.forEach((object: ExtraFields) => {
        const newArray: any[] = [
          `${object.label}`,
          `${siteInfo[object.id]}`,
          `${object.id}`,
          `${object.type}`,
          object.choices,
        ];
        object.choices
          ? (newArray[4] = object.choices)
          : (newArray[4] = object.options);
        // ENG-2535: [5] = visible_when display rule (absent = always shown)
        newArray[5] = object.visible_when;
        newVMSVariables.push(newArray);
      });
      setVmsVariables(newVMSVariables);

      // For AutoPatrol sites, also set vmsVariables in Zustand store
      if (siteInfo.integration_type_name === "autopatrol") {
        useSiteAboutStore.getState().setVmsVariables(newVMSVariables);
      }

      localStorage.setItem("siteInfo", JSON.stringify(siteInfo));
      localStorage.setItem("integrationType", siteInfo.onboarding_integration);
      if (siteInfo.auto_add) {
        localStorage.setItem("autoAdd", "true");
        autoAdd = true;
      } else {
        localStorage.setItem("autoAdd", "false");
        autoAdd = false;
      }
      if (siteInfo.armed) {
        setArmedStatus(true);
      }
      if (!siteInfo.armed) {
        setArmedStatus(false);
      }
      if (
        siteInfo.armed_status === "DISARMING" ||
        siteInfo.armed_status === "NOT_RUNNING"
      ) {
        setArmedStatus(false);
      }
      if (
        siteInfo.armed_status === "WARNING" ||
        siteInfo.armed_status === "ERROR" ||
        siteInfo.armed_status === "ARMED_OUTSIDE_SCHEDULE" ||
        siteInfo.armed_status === "ARMING"
      ) {
        setArmedStatus(true);
      }

      setActiveTab(<></>);
      // For autopatrol sites: vCH-only shows SchedulesTab; has AutoPatrol schedule shows empty (SiteAboutAutoPatrol mounts and manages its own tabs)
      if (siteInfo.integration_type_name === "autopatrol") {
        const vCHOnly = useSiteAboutStore.getState().vCHOnlySchedules;
        if (vCHOnly) {
          setActiveTab(<SchedulesTab siteInfo={siteInfo} />);
        } else {
          setActiveTab(<></>);
        }
      } else {
        setActiveTab(
          <GeneralInfoTab
            siteInfo={siteInfo}
            setSiteInfo={setSiteInfo}
            setActiveTab={setActiveTab}
            vmsVariables={newVMSVariables}
          />
        );
      }
      localStorage.setItem("integrationType", siteInfo.onboarding_integration);
      if (siteInfo.auto_add) {
        localStorage.setItem("autoAdd", "true");
        autoAdd = true;
      } else {
        localStorage.setItem("autoAdd", "false");
        autoAdd = false;
      }
      if (siteInfo.integration_type_name === "ailink") {
        setAiLinkSite(true);
      }
      if (
        !siteInfo.settings_deployed &&
        siteInfo.integration_type_name !== "ailink"
      ) {
        setSiteDeployed(false);
        setSyncNeeded(true);
      }
      if (siteInfo.settings_deployed) {
        siteInfoSettingsDeployed = true;
      }
      if (!siteInfo.settings_deployed) {
        siteInfoSettingsDeployed = false;
      }
      if (siteInfo.armed_status === "DISARMING") {
        setToolTipTitle(
          "Disarm command received. Site is in the process of disarming.  It may take a few moments for arm status to update."
        );
      }
      if (siteInfo.armed_status === "ARMING") {
        setToolTipTitle(
          "Arm command received. Site is in the process of arming. It may take a few moments for arm status to update."
        );
      }
      if (siteInfo.show_configure_motion) {
        setConfigureMotion(true);
      } else {
        setConfigureMotion(false);
      }
      emitLoadingPhase(
        "site-metadata",
        undefined,
        "handleGetAllData:site-metadata"
      );
    },
    (reason: AxiosError) => {
      getSiteInfoFail = true;

      if (isResourceNotFoundError(reason)) {
        setBackdropLoadingScreenOn(false);
        navigateToResourceNotFound(navigate, "site", siteId);
        return;
      }

      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        setBackdropLoadingScreenOn(false);

        if (localStorage.siteInfo) {
          try {
            const cachedSiteInfo = JSON.parse(localStorage.siteInfo);
            if (String(cachedSiteInfo?.id) === String(siteId)) {
              setSiteInfo(cachedSiteInfo);
              setDataLoaded(true);
            }
          } catch {
            // Ignore invalid cached site info.
          }
        }

        localStorage.setItem("autoAdd", "true");
        autoAdd = true;
      });
    }
  );
  !getSiteInfoFail &&
    (await AxiosUI.get(`nvr_camera/extra_fields/?customer__id=${siteId}`).then(
      (response: AxiosResponse) => {
        getExtraFieldsFail = false;
        localStorage.setItem(
          "additionalFieldNamesArray",
          JSON.stringify(response.data)
        );
        emitLoadingPhase(
          "site-extra-fields",
          undefined,
          "handleGetAllData:site-extra-fields"
        );
      },
      (reason: AxiosError) => {
        getExtraFieldsFail = true;
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {});
      }
    ));
  if (!getSiteInfoFail && !getExtraFieldsFail) {
    await getSiteCameras(1, autoPatrolSite);
  }
};
